import * as PropTypes from 'prop-types';
import * as React from 'react';
import BankAccountFieldsSelector from './bank_account_fields/bank_account_fields_selector';

class BankAccountFields extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      countryCode: props.countryCode,
    };
  }

  onCountryChange(countryCode) {
    this.setState({ countryCode });
    this.props.onCountryChange(countryCode);
  }

  get securelyStoredDataParagraph() {
    const text = I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.storedSecurelyAndEncryptedHtml', { icon: this.lockIcon });
    return (
      <p
        className="small muted scaling-mb-half"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }

  get lockIcon() {
    return '<span class="fa fa-lock"></span>';
  }

  nameForField(fieldName) {
    return `${this.props.fieldsNamePrefix}[${fieldName}]`;
  }

  supportedCurrenciesForCountry(countryCode) {
    return this.props.currencies[countryCode].supported;
  }

  renderCountrySpecificBankFields() {
    return (
      <BankAccountFieldsSelector
        selectedBankCountry={this.state.countryCode}
        bankLookupUrl={this.props.bankLookupUrl}
        nameForField={fieldName => this.nameForField(fieldName)}
        onCountryChange={countryCode => this.onCountryChange(countryCode)}
        onCurrencyChange={this.props.onCurrencyChange}
        countryCodeOptions={this.props.countryCodeOptions}
        currencies={this.supportedCurrenciesForCountry(this.state.countryCode)}
        selectedPayoutCurrency={this.props.selectedPayoutCurrency}
        shopCurrency={this.props.shopCurrency}
        dashboardView={this.props.dashboardView}
      />
    );
  }

  render() {
    return (
      <div>
        <p className="strong mb-0">
          {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankInfo')}
        </p>
        {this.securelyStoredDataParagraph}
        <p className="hint mb-1 mobile-mt-1 mobile-mb-2">
          {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.weNeedYourBankInfo')}
        </p>
        <div data-bank-account-fields>
          {this.renderCountrySpecificBankFields()}
        </div>
      </div>
    );
  }
}

BankAccountFields.propTypes = {
  fieldsNamePrefix: PropTypes.string.isRequired,
  bankLookupUrl: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  countryCodeOptions: PropTypes.array.isRequired,
  currencies: PropTypes.object.isRequired,
  onCountryChange: PropTypes.func,
  onCurrencyChange: PropTypes.func,
  selectedPayoutCurrency: PropTypes.string.isRequired,
  shopCurrency: PropTypes.string.isRequired,
  dashboardView: PropTypes.bool.isRequired,
};

export default BankAccountFields;



// WEBPACK FOOTER //
// ./javascripts/components/shop/direct_checkout_profile/bank_account_fields.jsx